import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  ViewEncapsulation
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Panel, PanelStyle } from 'primeng/panel';
import { PrimeTemplate } from 'primeng/api';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-panel',
  templateUrl: './m-panel.component.html',
  styleUrls: ['./m-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MPanelComponent),
      multi: true
    },
    PanelStyle
  ],
  imports: [Panel, PrimeTemplate]
})
export class MPanelComponent extends Panel {
  // PrimeNG 20 applies the root host class via `host: { '[class]': "cn(cx('root'), styleClass)" }`.
  // This wrapper renders its OWN inner <p-panel>, so the class is inherited onto <m-panel> too —
  // duplicating panel styling. Neutralize on the wrapper host; the inner instance is unaffected.
  override cx(): string {
    return '';
  }
}
